import cellStyle from './cellStyle'

export default { cellStyle }
